import { AutoCompleteModule } from 'primeng/autocomplete';
import { Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadModule, FileUploadEvent, FileSelectEvent, FileRemoveEvent } from 'primeng/fileupload';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TabViewModule } from 'primeng/tabview';
import { MessageService } from 'primeng/api';
import { DirectionService } from '../../../../../services/direction.service';
import { TranslateService } from '../../../../../services/translate.service';
import { IndexInsertService, UploadedFileInfo } from './index-insert.service';
import { AjaxService } from '../../../../../services/ajax.service';
import { TagModule } from 'primeng/tag';
import { FormsModule } from '@angular/forms';
import { IndexInsertComponent } from '../../../index-insert/index-insert.component';
import { ButtonModule } from 'primeng/button';
import { CreateAccountService } from '../../create-account.service';

@Component({
	selector: 'app-index-insert-step',
	standalone: true,
	imports: [
		CommonModule, FileUploadModule, TagModule,ButtonModule , TableModule, ToastModule, TabViewModule, AutoCompleteModule, FormsModule,
		IndexInsertComponent
	],
	templateUrl: './index-insert.component.html',
	styleUrls: ['./index-insert.component.scss'],
	providers: [
		MessageService,
		IndexInsertService, 
		DirectionService,   
		TranslateService,   
		AjaxService         
	]
})
export class IndexInsertStepComponent {
	@Output() nextStep = new EventEmitter<void>();
	@Output() prevStep = new EventEmitter<void>();
	@ViewChild('indexInsert') indexInsertComponent: any;

	// Mode flag (should be set from parent or config if needed)
	isDialogMode = false;

	// Expose translation and direction services for template
	constructor(
		public translateServ: TranslateService,
		public dirServ: DirectionService,
		private createAccountService: CreateAccountService
	) {}


	get canGoNextDialog(): boolean 
	{
		const result = this.indexInsertComponent?.finishTabState === 'done';
		if(result) this.memorizeThatDone();
		return result || this.didWeDidItAlready();
	}

	private memorizeThatDone(): void
	{	
		const tabKey = this.constructor.name;
		this.createAccountService.memorizeAnObject(tabKey, {"filled" : true});
	}

	public didWeDidItAlready(): boolean 
	{
		const tabKey = this.constructor.name;
		const val = this.createAccountService.readObject(tabKey);
		if (typeof val === 'object' && val !== null && 'filled' in val) {
			return !!val.filled;
		}
		return !!val;
	}
}
